import { HTMLAttributes } from 'react';
import { motion } from 'framer-motion';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'glass' | 'dark';
  hover?: boolean;
}

export default function Card({
  children,
  variant = 'default',
  hover = false,
  className = '',
  ...props
}: CardProps) {
  const variantStyles = {
    default: 'bg-[var(--card)] border border-[var(--border)]',
    glass: 'bg-[var(--card)]/80 backdrop-blur-lg border border-[var(--border)]',
    dark: 'bg-[var(--bg)] border border-[var(--border)]',
  };

  const hoverStyles = hover
    ? 'transition-all duration-300 hover:shadow-2xl hover:-translate-y-1'
    : '';

  return (
    <motion.div
      className={`rounded-2xl shadow-lg p-6 ${variantStyles[variant]} ${hoverStyles} ${className}`}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      {...props as any}
    >
      {children}
    </motion.div>
  );
}
